module.exports = __webpack_public_path__ + "img/lunch.64727fe1.svg";